import request from '@/utils/request'

export function getConfig(params) {
  return request({
    url: '/super/Config/index',
    method: 'get',
    params,
  })
}

export function postConfig(data) {
  return request({
    url: '/super/config/create',
    method: 'post',
    data,
  })
}

export function methodConfig(data) {
  return request({
    url: `/super/config/update`,
    method: 'post',
    data,
  })
}

export function sendSms(data) {
  return request({
    url: '/super/config/testSendSms',
    method: 'post',
    data,
  })
}

export function handleLog(params) {
  return request({
    url: '/super/HandleLog/index',
    method: 'get',
    params,
  })
}

export function getBucket(data) {
  return request({
    url: '/super/system/getBucket',
    method: 'post',
    data,
  })
}
//配送设置
export function setupDis(data) {
  return request({
    url: '/channel/delivery/channel',
    method: 'post',
    data,
  })
}

//检查更新
export function checkForUpdates(data) {
  return request({
    url: '/super/system/checkForUpdates',
    method: 'post',
    data,
  })
}
//更新
export function updateSystem(data) {
  return request({
    url: '/super/system/updateSystem',
    method: 'post',
    data,
  })
}
//获取更新进度
export function getUpdateProgress() {
  return request({
    url: '/super/system/getUpdateProgress',
    method: 'get',
  })
}
//手动替换前端域名
export function replaceFrontendDomain(data) {
  return request({
    url: '/super/system/replaceFrontendDomain',
    method: 'post',
    data,
  })
}
//手动升级数据库
export function upgradeDatabase(data) {
  return request({
    url: '/super/system/upgradeDatabase',
    method: 'post',
    data,
  })
}
// 更新日志
export function getUpdateAnnouncementList(data) {
  return request({
    url: '/api/system/get-update-announcement-list',
    method: 'post',
    data,
  })
}

export function getUpdateLogList() {
  return request({
    url: '/super/system/updateLog',
    method: 'get'
  })
}

export function getApp() {
  return request({
    url: '/super/system/getApp',
    method: 'get'
  })
}
//小程序列表
export function getWechatList(params) {
  return request({
    url: '/api/system/get-wechat-list',
    method: 'get',
    params,
  })
}
//创建小程序
export function createWechat(data) {
  return request({
    url: '/api/system/create-wechat',
    method: 'post',
    data,
  })
}

export function uploadImage(data) {
  return request({
    url: '/api/system/upload-image',
    method: 'post',
    data,
  })
}

export function getVersion(params) {
  return request({
    url: '/super/openWechat/version',
    method: 'get',
    params,
  })
}

export function miniUpload(data) {
  return request({
    url: '/super/openWechat/ciUpload',
    method: 'post',
    data,
    loading: '小程序代码上传中，预计时间10~15s',
    errorMsg:
      '小程序代码上传失败，请检查小程序上传白名单是否关闭或上传密钥配置。',
  })
}

export function businessUpload(data) {
  return request({
    url: '/super/openWechat/ciUploadbusiness',
    method: 'post',
    data,
    loading: '店铺助手代码上传中，预计时间10~15s',
    errorMsg:
      '店铺助手代码上传失败，请检查配置信息。',
  })
}

export function draftBox(params) {
  return request({
    url: '/super/openWechat/draftbox',
    method: 'get',
    params,
  })
}

export function draftTemplateListBox(params) {
  return request({
    url: '/super/openWechat/templateList',
    method: 'get',
    params,
  })
}

export function templateSelect(data) {
  return request({
    url: '/super/openWechat/templateSelect',
    method: 'post',
    data,
  })
}

export function templateDelete(data) {
  return request({
    url: `/super/openWechat/templateDelete`,
    method: 'delete',
    data,
  })
}

export function miniRelease(data) {
  return request({
    url: '/super/openWechat/release',
    method: 'post',
    data,
  })
}

export function createOrder(data) {
  return request({
    url: '/api/plug/create-order',
    method: 'post',
    data,
  })
}

export function checkPaymentStatus(data) {
  return request({
    url: '/api/plug/check-payment-status',
    method: 'post',
    data,
  })
}
export function systemInfo(params) {
  return request({
    url: '/api/system/index',
    method: 'get',
    params,
  })
}
/* 检测swoole */
export function systemCheck(params) {
  return request({
    url: '/api/system/checkswoole',
    method: 'get',
    params,
  })
}
/* 检测redis */
export function checkRedis(params) {
  return request({
    url: '/api/system/checkRedis',
    method: 'get',
    params,
  })
}
/* 清理缓存 */
export function clearCache(params) {
  return request({
    url: '/api/system/clearCache',
    method: 'get',
    params,
  })
}
/* 重启任务队列 */
export function queueRestart(params) {
  return request({
    url: '/api/system/queueRestart',
    method: 'get',
    params,
  })
}
/* 清理队列任务 */
export function clearQueue(params) {
  return request({
    url: '/api/system/clearQueue',
    method: 'get',
    params,
  })
}
/* 同步短信账户 */
export function syncSms(params) {
  return request({
    url: '/api/system/syncSms',
    method: 'get',
    params,
  })
}
/* 同步圈子账户 */
export function syncCircle(params) {
  return request({
    url: '/api/system/syncCircle',
    method: 'get',
    params,
  })
}
/* 订单列表 */
export function order(params) {
  return request({
    url: '/super/AdminPayOrder/index',
    method: 'get',
    params,
  })
}
/* 检测第三方店铺是否可用 */
export function openWechatCheck() {
  return request({
    url: '/super/openWechat/check',
    method: 'post',
  })
}

export function getPayTemplate(params, id = '') {
  return request({
    url: `/api/payConfig/${id}`,
    method: 'get',
    params,
  })
}

export function payTemplate(data, method, id = '') {
  return request({
    url: `/api/payConfig/${id}`,
    method,
    data,
  })
}
// 授权管理
export function getSystemInfo() {
  return request({
    url: '/api/getSystemInfo',
    method: 'get',
  })
}

export function waiSongBang(data) {
  return request({
    url: '/api/waisongbang',
    method: 'post',
    data,
  })
}

//商家助手上传
export function uploadMerchant(data) {
  return request({
    url: '/api/mini-upload/merchant',
    method: 'post',
    data,
  })
}

//获取系统插件
export function getPlugList() {
  return request({
    url: '/api/plug/list',
    method: 'get',
  })
}

export async function getHelpers(params) {
  return request({
    url: `/api/helpers`,
    method: "get",
    params,
  });
}

export async function postHelpers(data) {
  return request({
    url: `/api/helpers`,
    method: "post",
    data,
  });
}

export async function opHelpers(method, id, data) {
  return request({
    url: `/api/helpers/${id}`,
    method,
    data,
  });
}

//公众号订单提醒-发送测试
export async function sendStoreTemplates(data) {
  return request({
    url: `/api/sendStoreTemplates`,
    method: "post",
    data,
  });
}

// APP版本设置 - 获取配置
export function getAppVersion() {
  return request({
    url: '/super/Config/index',
    method: 'get',
    params: { ident: 'appVersion' },
  })
}

// APP版本设置 - 保存配置
export function saveAppVersion(data) {
  return request({
    url: '/super/config/saveAppVersion',
    method: 'post',
    data,
  })
}

// 数据清除 - 预览
export function dataClearPreview(enterpriseId) {
  return request({
    url: '/super/DataClear/preview',
    method: 'get',
    params: { enterpriseId },
  })
}

// 数据清除 - 执行
export function dataClearExecute(data) {
  return request({
    url: '/super/DataClear/execute',
    method: 'post',
    data,
  })
}
